import React from 'react';
import { Link } from 'react-router-dom';

const TheAdventure = () => {
  const wildlife = [
    {
      title: 'Five Male Cheetah',
      description: 'On the Burangat and Posse Plains in the South of the reserve five male Cheetah can often be seen hunting Thompson Gazelle and Impala.',
      image: 'https://images.unsplash.com/photo-1679921310127-f6ae5620a403?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHw0fHxhZnJpY2FuJTIwc2F2YW5uYWglMjB3aWxkbGlmZXxlbnwwfHx8fDE3NjMwNzEwOTR8MA&ixlib=rb-4.1.0&q=85'
    },
    {
      title: 'Lions of Mara',
      description: 'There are many prides in Uganda. Our flights frequently take us over areas where prides or lone lions are regularly seen on morning flights.',
      image: 'https://images.unsplash.com/photo-1729359035276-189519a4b072?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxhZnJpY2FuJTIwc2F2YW5uYWglMjB3aWxkbGlmZXxlbnwwfHx8fDE3NjMwNzEwOTR8MA&ixlib=rb-4.1.0&q=85'
    },
    {
      title: 'Wildebeest - Great Migration',
      description: 'During the migration herds of Wildebeest can be seen crossing daily in large numbers, moving into the southern Reserve.',
      image: 'https://images.unsplash.com/photo-1731994634956-94a42f6b6290?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwzfHxhZnJpY2FuJTIwc2F2YW5uYWglMjB3aWxkbGlmZXxlbnwwfHx8fDE3NjMwNzEwOTR8MA&ixlib=rb-4.1.0&q=85'
    }
  ];

  return (
    <div className="min-h-screen pt-20">
      <section
        className="relative h-96 flex items-center justify-center text-white"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1707410463039-3ea2d47a4f06?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwzfHxob3QlMjBhaXIlMjBiYWxsb29uJTIwc2FmYXJpfGVufDB8fHx8MTc2MzA3MTA4OHww&ixlib=rb-4.1.0&q=85)',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="absolute inset-0 bg-black/50"></div>
        <div className="relative z-10 text-center px-4">
          <h1 className="text-5xl md:text-6xl font-bold">The Adventure</h1>
          <p className="text-xl mt-4">Your destination awaits</p>
        </div>
      </section>

      <section className="py-20 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-6">
              Ultimate ballooning destination
            </h2>
            <p className="text-xl text-gray-700 italic mb-8">
              A journey of emotion…for many…a dream of a lifetime
            </p>
            <blockquote className="text-lg text-gray-600">
              "What a fantastic way to see Uganda national park from the sky!"
              <footer className="text-sm text-gray-500 mt-2">– Trip Advisor October 2019</footer>
            </blockquote>
          </div>

          <div className="prose prose-lg max-w-4xl mx-auto mb-16">
            <p className="text-gray-700 leading-relaxed mb-6">
              Recognised as one of Africa's Greatest Wildlife Reserves, Uganda National Game Reserve is bordered by the Serengeti National Park in the South, Siria Plateau and Oloololo Escarpment in the West.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Every day is different, but typically you will see a wide range of wildlife; in any one flight you are likely to see Giraffe, Elephant, Topi, various Gazelle, Zebra, Hyena and Ostrich. For the keen eyed you may also fly over Cheetah, Lion and sometimes spot the elusive Leopard or even Rhino.
            </p>
          </div>

          <h3 className="text-3xl font-bold text-gray-800 mb-8 text-center">
            Wildlife You May Encounter
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
            {wildlife.map((animal, index) => (
              <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden">
                <img
                  src={animal.image}
                  alt={animal.title}
                  className="w-full h-64 object-cover"
                />
                <div className="p-6">
                  <h4 className="text-xl font-bold text-gray-800 mb-3">{animal.title}</h4>
                  <p className="text-gray-600">{animal.description}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="text-white p-12 rounded-lg text-center" style={{ backgroundColor: '#EE6A1F' }}>
            <h3 className="text-3xl font-bold mb-6">What makes these trips different?</h3>
            <p className="text-xl mb-8">
              Creating memories that will last you a lifetime. It has to be on everyone's Bucket List!
            </p>
            <Link
              to="/contact"
              className="inline-block font-bold px-8 py-3 rounded transition-transform bg-[#EE6A1F] text-white border border-white/60 shadow-lg hover:scale-105"
            >
              BOOK YOUR ADVENTURE
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TheAdventure;
